(function() {
  var cutlistBody = document.getElementById('tms-cutlist-body');
  var addRowBtn = document.getElementById('tms-add-row');
  var exportCsvBtn = document.getElementById('tms-export-csv');
  var copySummaryBtn = document.getElementById('tms-copy-summary');
  var clearListBtn = document.getElementById('tms-clear-list');
  var undoClearWrap = document.getElementById('tms-undo-clear');
  var undoClearBtn = document.getElementById('tms-undo-clear-btn');
  var saveStatus = document.getElementById('tms-save-status');
  var saveStatusText = document.getElementById('tms-save-status-text');
  var emptyState = document.getElementById('tms-cutlist-empty');

  var summaryParts = document.getElementById('tms-summary-parts');
  var summaryPieces = document.getElementById('tms-summary-pieces');
  var summaryLength = document.getElementById('tms-summary-length');
  var summaryVolume = document.getElementById('tms-summary-volume');
  var summaryWaste = document.getElementById('tms-summary-waste');
  var summaryAdjusted = document.getElementById('tms-summary-adjusted');
  var summaryGroups = document.getElementById('tms-summary-groups');
  var summaryMaterials = document.getElementById('tms-summary-materials');

  if (!cutlistBody || !addRowBtn || !exportCsvBtn || !copySummaryBtn || !clearListBtn || !undoClearBtn) return;

  var STORAGE_KEY = 'tms-cutting-list-calculator-v2';
  var undoSnapshot = null;
  var undoTimer = null;
  var saveStatusTimer = null;

  var defaultRows = [
    { name: 'Side panel', material: 'Birch Plywood', group: 'Carcass', thickness: 18, width: 300, length: 720, qty: 2 },
    { name: 'Shelf', material: 'Birch Plywood', group: 'Shelves', thickness: 18, width: 280, length: 560, qty: 3 },
    { name: 'Top rail', material: 'Solid Oak', group: 'Face Frame', thickness: 20, width: 80, length: 900, qty: 2 }
  ];

  var defaultAllowances = {
    'Birch Plywood': 10,
    'Solid Oak': 15
  };

  var materialAllowances = Object.assign({}, defaultAllowances);
  var materialAllowanceDrafts = {};

  function formatNumber(value, digits) {
    if (!isFinite(value)) return '0';
    return Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits || 2
    });
  }

  function formatLengthMmToM(mm) {
    return formatNumber(mm / 1000, 2) + ' m';
  }

  function mm3ToM3(mm3) {
    return mm3 / 1000000000;
  }

  function mm3ToCft(mm3) {
    return mm3ToM3(mm3) * 35.3146667;
  }

  function formatVolumeDualFromMm3(mm3) {
    var m3 = mm3ToM3(mm3);
    var cft = mm3ToCft(mm3);
    return (
      '<div class="tms-volume-dual">' +
        '<div class="tms-volume-dual__main">' + escapeHtml(formatNumber(m3, 4)) + ' m3</div>' +
        '<div class="tms-volume-dual__sub">' + escapeHtml(formatNumber(cft, 2)) + ' cft</div>' +
      '</div>'
    );
  }

  function formatVolumeDualTextFromMm3(mm3) {
    return formatNumber(mm3ToM3(mm3), 4) + ' m3 / ' + formatNumber(mm3ToCft(mm3), 2) + ' cft';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function csvEscape(value) {
    var str = String(value == null ? '' : value);
    if (/[",\n]/.test(str)) {
      return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
  }

  function createInput(type, className, value, placeholder, min, step) {
    var input = document.createElement('input');
    input.type = type;
    input.className = className;
    input.value = value != null ? value : '';
    if (placeholder) input.placeholder = placeholder;
    if (min != null) input.min = min;
    if (step != null) input.step = step;
    return input;
  }

  function getMaterialKey(material) {
    var key = String(material || '').trim();
    return key || 'Unspecified';
  }

  function getGroupKey(group) {
    var key = String(group || '').trim();
    return key || 'Unspecified';
  }

  function getAllowancePercent(material) {
    var key = getMaterialKey(material);
    var value = materialAllowances[key];
    value = parseFloat(value);
    if (!isFinite(value) || value < 0) return 0;
    return value;
  }

  function getAllowanceDraftValue(material) {
    var key = getMaterialKey(material);
    if (Object.prototype.hasOwnProperty.call(materialAllowanceDrafts, key)) {
      return materialAllowanceDrafts[key];
    }
    return String(getAllowancePercent(key));
  }

  function setSaveStatus(mode, text) {
    saveStatus.classList.remove('is-pending', 'is-error');
    if (mode === 'pending') saveStatus.classList.add('is-pending');
    if (mode === 'error') saveStatus.classList.add('is-error');
    saveStatusText.textContent = text;
  }

  function formatSavedTime(date) {
    try {
      return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    } catch (error) {
      return '';
    }
  }

  function readRow(tr) {
    var inputs = tr.querySelectorAll('input');
    return {
      name: inputs[0].value.trim(),
      material: inputs[1].value.trim(),
      group: inputs[2].value.trim(),
      thickness: parseFloat(inputs[3].value),
      width: parseFloat(inputs[4].value),
      length: parseFloat(inputs[5].value),
      qty: parseInt(inputs[6].value, 10)
    };
  }

  function getRows() {
    return Array.prototype.slice.call(cutlistBody.querySelectorAll('tr'));
  }

  function serializeRows() {
    var rows = getRows();
    var data = [];

    for (var i = 0; i < rows.length; i++) {
      var row = readRow(rows[i]);
      data.push({
        name: row.name,
        material: row.material,
        group: row.group,
        thickness: isFinite(row.thickness) ? row.thickness : '',
        width: isFinite(row.width) ? row.width : '',
        length: isFinite(row.length) ? row.length : '',
        qty: isFinite(row.qty) ? row.qty : ''
      });
    }

    return data;
  }

  function getCurrentStateSnapshot() {
    return {
      rows: serializeRows(),
      materialAllowances: JSON.parse(JSON.stringify(materialAllowances || {}))
    };
  }

  function saveState() {
    try {
      setSaveStatus('pending', 'Saving...');
      var payload = {
        rows: serializeRows(),
        materialAllowances: materialAllowances,
        updatedAt: new Date().toISOString()
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));

      if (saveStatusTimer) window.clearTimeout(saveStatusTimer);
      saveStatusTimer = window.setTimeout(function() {
        setSaveStatus('saved', 'Saved automatically - ' + formatSavedTime(new Date()));
      }, 80);
    } catch (error) {
      setSaveStatus('error', 'Unable to save on this device');
    }
  }

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function clearSavedState() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function showUndo(message) {
    if (undoTimer) window.clearTimeout(undoTimer);
    undoClearWrap.classList.add('is-visible');
    undoClearWrap.firstElementChild.textContent = message || 'The list was cleared.';
    undoTimer = window.setTimeout(function() {
      undoClearWrap.classList.remove('is-visible');
      undoSnapshot = null;
    }, 12000);
  }

  function hideUndo() {
    if (undoTimer) window.clearTimeout(undoTimer);
    undoClearWrap.classList.remove('is-visible');
  }

  function commitAllowanceValue(material, rawValue) {
    var key = getMaterialKey(material);
    var parsed = parseFloat(rawValue);

    if (rawValue === '') {
      materialAllowanceDrafts[key] = '';
      materialAllowances[key] = 0;
      updateSummary();
      saveState();
      return;
    }

    if (isFinite(parsed) && parsed >= 0) {
      materialAllowances[key] = parsed;
      materialAllowanceDrafts[key] = String(rawValue);
      updateSummary();
      saveState();
    }
  }

  function validateRow(tr, row) {
    var inputs = tr.querySelectorAll('input');
    var hasAnyValue = !!(
      row.name || row.material || row.group ||
      String(inputs[3].value).trim() || String(inputs[4].value).trim() ||
      String(inputs[5].value).trim() || String(inputs[6].value).trim()
    );

    var isValidDims = isFinite(row.thickness) && row.thickness > 0 &&
      isFinite(row.width) && row.width > 0 &&
      isFinite(row.length) && row.length > 0 &&
      isFinite(row.qty) && row.qty > 0;

    inputs[0].classList.toggle('is-invalid', hasAnyValue && !row.name);
    inputs[1].classList.toggle('is-invalid', hasAnyValue && !row.material);
    inputs[3].classList.toggle('is-invalid', hasAnyValue && (!isFinite(row.thickness) || row.thickness <= 0));
    inputs[4].classList.toggle('is-invalid', hasAnyValue && (!isFinite(row.width) || row.width <= 0));
    inputs[5].classList.toggle('is-invalid', hasAnyValue && (!isFinite(row.length) || row.length <= 0));
    inputs[6].classList.toggle('is-invalid', hasAnyValue && (!isFinite(row.qty) || row.qty <= 0));

    tr.classList.toggle('is-invalid', hasAnyValue && (!row.name || !row.material || !isValidDims));
    return { hasAnyValue: hasAnyValue, isValidDims: isValidDims };
  }

  function updateRow(tr) {
    var row = readRow(tr);
    var result = tr.querySelector('.tms-cutlist__line-result');
    var note = tr.querySelector('.tms-cutlist__line-note');
    var validation = validateRow(tr, row);

    tr.setAttribute('data-material', getMaterialKey(row.material));
    tr.setAttribute('data-group', getGroupKey(row.group));

    if (!validation.hasAnyValue) {
      tr.setAttribute('data-line-volume', '0');
      tr.setAttribute('data-line-length', '0');
      tr.setAttribute('data-line-qty', '0');
      result.innerHTML = '-';
      result.classList.add('is-muted');
      note.textContent = '';
      return;
    }

    if (!validation.isValidDims || !row.name || !row.material) {
      tr.setAttribute('data-line-volume', '0');
      tr.setAttribute('data-line-length', '0');
      tr.setAttribute('data-line-qty', '0');
      result.innerHTML = 'Complete required fields';
      result.classList.add('is-muted');

      var messages = [];
      if (!row.name) messages.push('add part name');
      if (!row.material) messages.push('add material');
      if (!isFinite(row.thickness) || row.thickness <= 0) messages.push('thickness > 0');
      if (!isFinite(row.width) || row.width <= 0) messages.push('width > 0');
      if (!isFinite(row.length) || row.length <= 0) messages.push('length > 0');
      if (!isFinite(row.qty) || row.qty <= 0) messages.push('qty > 0');
      note.textContent = messages.join(' - ');
      return;
    }

    var lineVolume = row.thickness * row.width * row.length * row.qty;
    var lineLength = row.length * row.qty;

    tr.setAttribute('data-line-volume', String(lineVolume));
    tr.setAttribute('data-line-length', String(lineLength));
    tr.setAttribute('data-line-qty', String(row.qty));

    result.innerHTML = formatVolumeDualFromMm3(lineVolume);
    result.classList.remove('is-muted');
    note.textContent = '';
  }

  function renderEmptyGroupMessage(container, label) {
    container.innerHTML = '';
    var empty = document.createElement('div');
    empty.className = 'tms-summary__group-item';
    empty.innerHTML = '<span>' + escapeHtml(label) + '</span><strong>-</strong>';
    container.appendChild(empty);
  }

  function renderGroupSummary(groupTotals) {
    summaryGroups.innerHTML = '';
    var keys = Object.keys(groupTotals);

    if (!keys.length) {
      renderEmptyGroupMessage(summaryGroups, 'No group totals yet');
      return;
    }

    keys.sort();

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var groupData = groupTotals[key];
      var item = document.createElement('div');
      item.className = 'tms-summary__group-item tms-summary__group-item--stack';
      item.innerHTML =
        '<div class="tms-summary__group-head">' +
          '<span>' + escapeHtml(key) + '</span>' +
          '<strong>' + formatVolumeDualFromMm3(groupData.volume) + '</strong>' +
        '</div>' +
        '<div class="tms-summary__group-meta">' +
          '<span>Total pieces: <strong>' + escapeHtml(String(groupData.pieces)) + '</strong></span>' +
          '<span>Total volume: <strong>' + escapeHtml(formatVolumeDualTextFromMm3(groupData.volume)) + '</strong></span>' +
        '</div>';
      summaryGroups.appendChild(item);
    }
  }

  function bindAllowanceInputs() {
    var allowanceInputs = summaryMaterials.querySelectorAll('input[data-material-key]');

    for (var i = 0; i < allowanceInputs.length; i++) {
      allowanceInputs[i].addEventListener('input', function() {
        var materialKey = this.getAttribute('data-material-key') || 'Unspecified';
        materialAllowanceDrafts[materialKey] = this.value;
      });

      allowanceInputs[i].addEventListener('change', function() {
        commitAllowanceValue(this.getAttribute('data-material-key') || 'Unspecified', this.value);
      });

      allowanceInputs[i].addEventListener('blur', function() {
        commitAllowanceValue(this.getAttribute('data-material-key') || 'Unspecified', this.value);
      });
    }
  }

  function renderMaterialSummary(materialTotals) {
    summaryMaterials.innerHTML = '';
    var keys = Object.keys(materialTotals);

    if (!keys.length) {
      renderEmptyGroupMessage(summaryMaterials, 'No material groups yet');
      return { waste: 0, adjusted: 0 };
    }

    keys.sort();

    var totalWaste = 0;
    var totalAdjusted = 0;

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var netVolume = materialTotals[key];
      var allowancePercent = getAllowancePercent(key);
      var wasteVolume = netVolume * (allowancePercent / 100);
      var adjustedVolume = netVolume + wasteVolume;
      var draftValue = getAllowanceDraftValue(key);

      totalWaste += wasteVolume;
      totalAdjusted += adjustedVolume;

      var card = document.createElement('div');
      card.className = 'tms-material-card';
      card.innerHTML =
        '<div class="tms-material-card__head">' +
          '<div class="tms-material-card__title">' + escapeHtml(key) + '</div>' +
          '<div class="tms-material-card__allowance">' +
            '<label for="tms-allowance-' + i + '">Allowance %</label>' +
            '<input id="tms-allowance-' + i + '" type="number" min="0" step="0.5" value="' + escapeHtml(draftValue) + '" data-material-key="' + escapeHtml(key) + '">' +
          '</div>' +
        '</div>' +
        '<div class="tms-material-card__stats">' +
          '<div class="tms-material-card__stat">' +
            '<div class="tms-material-card__stat-label">Net volume</div>' +
            '<div class="tms-material-card__stat-value">' + formatVolumeDualFromMm3(netVolume) + '</div>' +
          '</div>' +
          '<div class="tms-material-card__stat">' +
            '<div class="tms-material-card__stat-label">Waste</div>' +
            '<div class="tms-material-card__stat-value">' + formatVolumeDualFromMm3(wasteVolume) + '</div>' +
          '</div>' +
          '<div class="tms-material-card__stat">' +
            '<div class="tms-material-card__stat-label">Adjusted</div>' +
            '<div class="tms-material-card__stat-value">' + formatVolumeDualFromMm3(adjustedVolume) + '</div>' +
          '</div>' +
        '</div>';
      summaryMaterials.appendChild(card);
    }

    bindAllowanceInputs();
    return { waste: totalWaste, adjusted: totalAdjusted };
  }

  function updateSummary() {
    var rows = getRows();
    var uniqueParts = rows.length;
    var totalPieces = 0;
    var totalLength = 0;
    var totalVolume = 0;
    var materialTotals = {};
    var groupTotals = {};

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var qty = parseInt(row.getAttribute('data-line-qty') || '0', 10);
      var length = parseFloat(row.getAttribute('data-line-length') || '0');
      var volume = parseFloat(row.getAttribute('data-line-volume') || '0');
      var material = getMaterialKey(row.getAttribute('data-material'));
      var group = getGroupKey(row.getAttribute('data-group'));

      qty = isFinite(qty) ? qty : 0;
      length = isFinite(length) ? length : 0;
      volume = isFinite(volume) ? volume : 0;

      totalPieces += qty;
      totalLength += length;
      totalVolume += volume;

      if (!materialTotals[material]) materialTotals[material] = 0;
      materialTotals[material] += volume;

      if (!groupTotals[group]) groupTotals[group] = { pieces: 0, volume: 0 };
      groupTotals[group].pieces += qty;
      groupTotals[group].volume += volume;
    }

    summaryParts.textContent = String(uniqueParts);
    summaryPieces.textContent = String(totalPieces);
    summaryLength.textContent = formatLengthMmToM(totalLength);
    summaryVolume.innerHTML = formatVolumeDualFromMm3(totalVolume);

    renderGroupSummary(groupTotals);
    var adjustedTotals = renderMaterialSummary(materialTotals);

    summaryWaste.innerHTML = formatVolumeDualFromMm3(adjustedTotals.waste);
    summaryAdjusted.innerHTML = formatVolumeDualFromMm3(adjustedTotals.adjusted);

    emptyState.hidden = uniqueParts > 0;
  }

  function attachRowEvents(tr) {
    var inputs = tr.querySelectorAll('input');
    var duplicateBtn = tr.querySelector('.tms-cutlist__duplicate');
    var removeBtn = tr.querySelector('.tms-cutlist__remove');

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', function() {
        updateRow(tr);
        updateSummary();
        saveState();
      });

      inputs[i].addEventListener('change', function() {
        updateRow(tr);
        updateSummary();
        saveState();
      });
    }

    duplicateBtn.addEventListener('click', function() {
      var row = readRow(tr);
      addRow({
        name: row.name,
        material: row.material,
        group: row.group,
        thickness: isFinite(row.thickness) ? row.thickness : '',
        width: isFinite(row.width) ? row.width : '',
        length: isFinite(row.length) ? row.length : '',
        qty: isFinite(row.qty) ? row.qty : 1
      });
    });

    removeBtn.addEventListener('click', function() {
      tr.parentNode.removeChild(tr);
      updateSummary();
      saveState();
    });
  }

  function addRow(data, shouldSave) {
    var tr = document.createElement('tr');
    tr.className = 'tms-cutlist__row';

    var td1 = document.createElement('td');
    td1.appendChild(createInput('text', 'tms-cutlist__input tms-cutlist__input--name', data.name, 'Part name'));

    var td2 = document.createElement('td');
    td2.appendChild(createInput('text', 'tms-cutlist__input tms-cutlist__input--text', data.material, 'Material'));

    var td3 = document.createElement('td');
    td3.appendChild(createInput('text', 'tms-cutlist__input tms-cutlist__input--text', data.group, 'Group / Section'));

    var td4 = document.createElement('td');
    td4.appendChild(createInput('number', 'tms-cutlist__input tms-cutlist__input--num', data.thickness, '', '0', 'any'));

    var td5 = document.createElement('td');
    td5.appendChild(createInput('number', 'tms-cutlist__input tms-cutlist__input--num', data.width, '', '0', 'any'));

    var td6 = document.createElement('td');
    td6.appendChild(createInput('number', 'tms-cutlist__input tms-cutlist__input--num', data.length, '', '0', 'any'));

    var td7 = document.createElement('td');
    td7.appendChild(createInput('number', 'tms-cutlist__input tms-cutlist__input--num', data.qty, '', '1', '1'));

    var td8 = document.createElement('td');
    var result = document.createElement('div');
    result.className = 'tms-cutlist__line-result';
    result.textContent = '-';
    var note = document.createElement('div');
    note.className = 'tms-cutlist__line-note';
    td8.appendChild(result);
    td8.appendChild(note);

    var td9 = document.createElement('td');
    var actions = document.createElement('div');
    actions.className = 'tms-cutlist__row-actions';

    var duplicateBtn = document.createElement('button');
    duplicateBtn.type = 'button';
    duplicateBtn.className = 'tms-cutlist__icon-btn tms-cutlist__duplicate';
    duplicateBtn.setAttribute('aria-label', 'Duplicate row');
    duplicateBtn.textContent = '+';

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'tms-cutlist__icon-btn tms-cutlist__remove';
    removeBtn.setAttribute('aria-label', 'Remove row');
    removeBtn.textContent = 'x';

    actions.appendChild(duplicateBtn);
    actions.appendChild(removeBtn);
    td9.appendChild(actions);

    tr.appendChild(td1);
    tr.appendChild(td2);
    tr.appendChild(td3);
    tr.appendChild(td4);
    tr.appendChild(td5);
    tr.appendChild(td6);
    tr.appendChild(td7);
    tr.appendChild(td8);
    tr.appendChild(td9);

    cutlistBody.appendChild(tr);
    attachRowEvents(tr);
    updateRow(tr);
    updateSummary();

    if (shouldSave !== false) saveState();
  }

  function clearAllRows() {
    cutlistBody.innerHTML = '';
    updateSummary();
  }

  function restoreSnapshot(snapshot, shouldSave) {
    clearAllRows();
    materialAllowances = Object.assign({}, defaultAllowances, (snapshot && snapshot.materialAllowances) || {});
    materialAllowanceDrafts = {};

    var rows = (snapshot && snapshot.rows && snapshot.rows.length) ? snapshot.rows : defaultRows;
    for (var i = 0; i < rows.length; i++) addRow(rows[i], false);

    updateSummary();
    if (shouldSave !== false) saveState();
  }

  function resetToDefault() {
    restoreSnapshot({ rows: defaultRows, materialAllowances: defaultAllowances }, true);
  }

  function restoreFromSavedState() {
    var saved = loadState();

    if (!saved || !saved.rows || !saved.rows.length) {
      resetToDefault();
      return;
    }

    restoreSnapshot({
      rows: saved.rows,
      materialAllowances: Object.assign({}, defaultAllowances, saved.materialAllowances || {})
    }, false);

    var savedAt = saved.updatedAt ? new Date(saved.updatedAt) : null;
    if (savedAt && !isNaN(savedAt.getTime())) {
      setSaveStatus('saved', 'Restored saved list - ' + formatSavedTime(savedAt));
    } else {
      setSaveStatus('saved', 'Restored saved list');
    }
  }

  function buildPurchaseSummaryText() {
    var rows = getRows();
    var materialTotals = {};
    var totalAdjusted = 0;
    var totalNet = 0;
    var totalWaste = 0;

    for (var i = 0; i < rows.length; i++) {
      var volume = parseFloat(rows[i].getAttribute('data-line-volume') || '0');
      var material = getMaterialKey(rows[i].getAttribute('data-material'));
      if (!isFinite(volume) || volume <= 0) continue;
      if (!materialTotals[material]) materialTotals[material] = 0;
      materialTotals[material] += volume;
      totalNet += volume;
    }

    var keys = Object.keys(materialTotals).sort();
    var lines = ['Purchase Summary'];

    if (!keys.length) {
      lines.push('No valid material totals yet.');
      return lines.join('\n');
    }

    lines.push('');

    for (var j = 0; j < keys.length; j++) {
      var key = keys[j];
      var netVolume = materialTotals[key];
      var allowancePercent = getAllowancePercent(key);
      var wasteVolume = netVolume * (allowancePercent / 100);
      var adjustedVolume = netVolume + wasteVolume;

      totalWaste += wasteVolume;
      totalAdjusted += adjustedVolume;

      lines.push(
        key + ': ' +
        formatNumber(mm3ToCft(adjustedVolume), 2) + ' cft adjusted' +
        ' (' + formatNumber(mm3ToM3(adjustedVolume), 4) + ' m3)' +
        ' - net ' + formatNumber(mm3ToCft(netVolume), 2) + ' cft' +
        ' - allowance ' + formatNumber(allowancePercent, 1) + '%'
      );
    }

    lines.push('');
    lines.push('Total adjusted: ' + formatNumber(mm3ToCft(totalAdjusted), 2) + ' cft (' + formatNumber(mm3ToM3(totalAdjusted), 4) + ' m3)');
    lines.push('Total net: ' + formatNumber(mm3ToCft(totalNet), 2) + ' cft (' + formatNumber(mm3ToM3(totalNet), 4) + ' m3)');
    lines.push('Estimated waste: ' + formatNumber(mm3ToCft(totalWaste), 2) + ' cft (' + formatNumber(mm3ToM3(totalWaste), 4) + ' m3)');

    return lines.join('\n');
  }

  function copyPurchaseSummary() {
    var text = buildPurchaseSummaryText();

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() {
        setSaveStatus('saved', 'Purchase summary copied');
        if (saveStatusTimer) window.clearTimeout(saveStatusTimer);
        saveStatusTimer = window.setTimeout(function() {
          setSaveStatus('saved', 'Saved automatically - ' + formatSavedTime(new Date()));
        }, 1600);
      }).catch(function() {
        setSaveStatus('error', 'Unable to copy summary');
      });
      return;
    }

    try {
      var temp = document.createElement('textarea');
      temp.value = text;
      document.body.appendChild(temp);
      temp.select();
      document.execCommand('copy');
      document.body.removeChild(temp);
      setSaveStatus('saved', 'Purchase summary copied');
    } catch (error) {
      setSaveStatus('error', 'Unable to copy summary');
    }
  }

  function exportCsv() {
    var rows = getRows();
    var lines = [];

    lines.push([
      'Part Name',
      'Material',
      'Group / Section',
      'Thickness (mm)',
      'Width (mm)',
      'Length (mm)',
      'Quantity',
      'Line Volume (m3)',
      'Line Volume (cft)'
    ].map(csvEscape).join(','));

    for (var i = 0; i < rows.length; i++) {
      var row = readRow(rows[i]);
      var lineVolume = parseFloat(rows[i].getAttribute('data-line-volume') || '0');

      lines.push([
        row.name,
        row.material,
        row.group,
        isFinite(row.thickness) ? row.thickness : '',
        isFinite(row.width) ? row.width : '',
        isFinite(row.length) ? row.length : '',
        isFinite(row.qty) ? row.qty : '',
        isFinite(lineVolume) ? mm3ToM3(lineVolume).toFixed(4) : '',
        isFinite(lineVolume) ? mm3ToCft(lineVolume).toFixed(2) : ''
      ].map(csvEscape).join(','));
    }

    var blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    var now = new Date();
    var stamp = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0');

    link.href = url;
    link.download = 'cutting-list-' + stamp + '.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    setSaveStatus('saved', 'CSV exported');
  }

  addRowBtn.addEventListener('click', function() {
    addRow({
      name: '',
      material: '',
      group: '',
      thickness: '',
      width: '',
      length: '',
      qty: 1
    });
  });

  copySummaryBtn.addEventListener('click', copyPurchaseSummary);
  exportCsvBtn.addEventListener('click', exportCsv);

  clearListBtn.addEventListener('click', function() {
    var confirmed = window.confirm('Clear the entire cutting list and saved allowances on this device?');
    if (!confirmed) return;

    undoSnapshot = getCurrentStateSnapshot();
    clearSavedState();
    materialAllowances = Object.assign({}, defaultAllowances);
    materialAllowanceDrafts = {};
    cutlistBody.innerHTML = '';
    updateSummary();
    saveState();
    showUndo('The list was cleared.');
    setSaveStatus('saved', 'List cleared');
  });

  undoClearBtn.addEventListener('click', function() {
    if (!undoSnapshot) return;
    restoreSnapshot(undoSnapshot, true);
    hideUndo();
    undoSnapshot = null;
    setSaveStatus('saved', 'Clear undone');
  });

  restoreFromSavedState();
})();